export function pcCycleRegisterSnils() {
  const $block = $('.pc-cycle-nationality');
  if (!$block || $block.length === 0) return;

  $block.on('change', (e) => {
    const $t = $(e.currentTarget);

    if ($t.prop('checked')) {
      if (parseInt($t.val()) === 1) {
        $('.pc-cycle-register-snils').removeClass('hide');
      } else {
        $('.pc-cycle-register-snils').addClass('hide');
      }
    }
  });
}
